import { formatDate } from "./WorkOrderDetailLayout";

const DATE_CHANGE_FIELDS = new Set(["basicStartDate", "dueDate"]);

export const CHANGE_FIELD_LABELS: Record<string, string> = {
  asset: "Asset",
  basicStartDate: "Start date",
  categories: "Categories",
  description: "Description",
  dueDate: "Due date",
  instructions: "Instructions",
  plannerGroup: "Planner group",
  priority: "Priority",
  status: "Status",
  title: "Title",
  workType: "Work type",
};

// Date changes are stored as ISO timestamps; show them like every other date.
export function displayChangeValue(
  change: { field: string },
  value: string,
): string {
  return DATE_CHANGE_FIELDS.has(change.field) && value !== "None"
    ? formatDate(value)
    : value;
}
